





























































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Company } from '@/utils/Interfaces'
import NavDrawerNhapLieuListItem from './NavDrawerNhapLieuListItem.vue'

@Component({
  components: {
    NavDrawerNhapLieuListItem,
  }
})
export default class NavDrawerNhapLieu extends Vue {
  @Prop(Array) readonly companies!: Array<Company>

  show = false

  get parentCompanies () {
    return this.$store.getters.getParentCompanies
  }
  get subsidiaryCompanies () {
    return this.$store.getters.getSubsidiaryCompanies
  }
  get associatedCompanies () {
    return this.$store.getters.getAssociatedCompanies
  }
  get limitedCompanies () {
    return this.$store.getters.getLimitedCompanies
  }
}
